export const SMART_TYPE = {
  SMART_T: "Smart T",
  SMART_E: "Smart E",
  SMART_I: "Smart I",
  SMART_O: "Smart O",
  SMART_S: "Smart S",
};
export const SMART_NAME = {
  "Smart T": SMART_TYPE.SMART_T,
  "Smart E": SMART_TYPE.SMART_E,
  "Smart I": SMART_TYPE.SMART_I,
  "Smart O": SMART_TYPE.SMART_O,
  "Smart S": SMART_TYPE.SMART_S,
};
export const SMART_NAME_FULL = {
  "Smart T": "Talent",
  "Smart E": "Executives",
  "Smart I": "Investors",
  "Smart O": "Other",
  "Smart S": "Startup",
  Extension: "Extension",
};

export const SMART_NAME_ALIAS = {
  "Smart T": "T",
  "Smart E": "E",
  "Smart I": "I",
  "Smart O": "O",
  "Smart S": "S",
  Extension: "Ex",
};
